import React, { useState, useMemo, useEffect } from "react";
import "./style.less";
import {
  Popup,
  Checkbox,
  Tab,
  Label,
  Menu,
  Grid,
  Button
} from "semantic-ui-react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  fetchTaskDetails,
  markRmBuddyTaskAsDone
} from "../../../redux/rm-buddies/actions";
import TransferTaskButton from "../TransferTaskButton";
import RMBuddyTasksFilter from "../RMBuddyTasksFilter";
import moment from "moment";

import { isEmpty } from "lodash";

export const statusMapping = {
  RMBUDDY_COMPLETE: "Completed Task",
  PENDING: "Tasks in progress",
  REASSIGNED: "Transferred",
  DELAYED: "Delayed Task",
  UNALLOCATED: "Unallocated Tasks",
  CANCELLED: "Cancelled Tasks"
};

export const statusTagMapping = {
  PARTIAL_CANCEL: "Partial Cancel",
  FULL_CANCEL: "Full Cancel"
};

function MarkAsDoneButton({ taskIds, onSuccessAction }) {
  const dispatch = useDispatch();
  const markAsDone = () => {
    dispatch(markRmBuddyTaskAsDone({ taskIds, onSuccessAction }));
  };
  return (
    <span className="MarkAsDoneButton">
      <Button primary className="markAsDone" onClick={markAsDone}>
        Mark As Done
      </Button>
    </span>
  );
}

export const getTaskCategory = (task, taskStatus) => {
  if (taskStatus !== "ALL" && taskStatus !== "REASSIGNED") return taskStatus;
  if (task.status === "CANCELLED") {
    return "CANCELLED";
  }
  if (!task.assignedTo) {
    return "UNALLOCATED";
  }
  if (task.status === "RMBUDDY_COMPLETE" || task.status === "COMPLETE") {
    return "RMBUDDY_COMPLETE";
  }
  if (
    task.status === "PENDING" &&
    moment(task.dueAt) < moment() &&
    !task.statusTag
  ) {
    return "DELAYED";
  } else if (task.status === "PENDING") {
    return "PENDING";
  }
};

const checkSelectedTasksContains = (selectedTasks, categoryToCheck) => {
  if (isEmpty(selectedTasks) || isEmpty(categoryToCheck)) {
    return false;
  }
  for (let i = 0; i < selectedTasks.length; i++) {
    if (
      categoryToCheck.indexOf(getTaskCategory(selectedTasks[i], "ALL")) !== -1
    ) {
      return true;
    }
  }
  return false;
};

const getSortedArr = (arr, i) => {
  if (arr.find(e => e._id === i._id)) {
    return arr.filter(e => e._id !== i._id);
  }
  if (arr.length === 0) {
    return [i];
  }
  let pos = null;
  for (let index = 0; index < arr.length; index++) {
    if (arr[index].position > i.position) {
      pos = index;
      break;
    }
  }
  if (pos === 0) {
    return [i, ...arr];
  }
  if (pos === null) {
    return [...arr, i];
  }
  const result = [...arr.slice(0, pos), i, ...arr.slice(pos)];
  return result;
};

function TasksPaneContent({ tasksList, taskStatus, onSuccessAction }) {
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const dispatch = useDispatch();
  const taskDetails = useSelector(({ rmBuddies }) => rmBuddies.taskDetails);

  const buddyBlocksList = useSelector(
    ({ rmBuddies }) => rmBuddies.buddyBlocksList
  );

  const selectedTasksBuddyBlocks = useMemo(() => {
    return taskDetails
      ? taskDetails
          .map(e => buddyBlocksList.find(t => t._id === e.belongsToBuddyBlock))
          .filter(e => !isEmpty(e))
      : null;
  }, [buddyBlocksList, taskDetails]);
  console.log(selectedTasksBuddyBlocks, "yo idhar");
  useEffect(() => {
    setSelectedTaskIds([]);
  }, [tasksList, setSelectedTaskIds]);

  useEffect(() => {
    if (selectedTaskIds && selectedTaskIds.length > 0) {
      dispatch(fetchTaskDetails(selectedTaskIds));
    }
  }, [dispatch, selectedTaskIds]);

  return (
    <div className="TasksPaneContent">
      {tasksList && tasksList.length > 0 ? (
        <Grid>
          <Grid.Column width={7}>
            <div className="TaskDetailSelectorContainer">
              {tasksList.map((e, i) => (
                <div
                  key={i}
                  onClick={() =>
                    setSelectedTaskIds(
                      getSortedArr(selectedTaskIds, {
                        position: i,
                        _id: e._id
                      })
                    )
                  }
                  className={`${
                    selectedTaskIds &&
                    selectedTaskIds.find(s => s._id === e._id)
                      ? "active"
                      : ""
                  } TaskDetailSelector`}
                >
                  <Grid>
                    <Grid.Column width={4}>
                      <div className="RmBuddyAvatar">
                        <div className="RmBuddyAvatarInitials">
                          {e.assignedTo
                            ? `${e.assignedTo.name.charAt(
                                0
                              )}${e.assignedTo.name.charAt(1)}`.toUpperCase()
                            : "!!"}
                        </div>
                      </div>
                    </Grid.Column>
                    <Grid.Column width={10}>
                      <p className="TasksId">
                        Tasks ID: #{e.taskUniqueId.substring(0, 5)}...
                        {e.taskUniqueId.substring(25)}
                      </p>
                      <p className="TasksType">Task Type: {e.taskType}</p>
                      <p className="TasksAssignedTo">
                        RM Buddy: {e.assignedTo ? e.assignedTo.name : "NULL"}
                      </p>
                      <br />

                      {taskStatus === "REASSIGNED" ? (
                        <p className="REASSIGNED">
                          {statusMapping["REASSIGNED"]}
                        </p>
                      ) : null}

                      <p className={getTaskCategory(e, taskStatus)}>
                        {statusMapping[getTaskCategory(e, taskStatus)]}
                      </p>
                    </Grid.Column>
                    <Grid.Column width={2}></Grid.Column>
                  </Grid>
                </div>
              ))}
            </div>
          </Grid.Column>
          {taskDetails && selectedTaskIds && selectedTaskIds.length > 0 && (
            <Grid.Column width={9}>
              <div style={{ overflow: "auto", height: "95%" }}>
                {taskDetails.map((e, i) => (
                  <div>
                    <h4>Tasks ID: </h4>
                    <h3>
                      #{e.taskUniqueId.substring(0, 5)}...
                      {e.taskUniqueId.substring(25)}
                    </h3>
                    <br />
                    <Grid className="TaskDetailsTable">
                      <Grid.Row>
                        <Grid.Column width={6}>Task Type:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {" "}
                          {e.taskType}{" "}
                        </Grid.Column>
                      </Grid.Row>

                      {e.statusTag && (
                        <Grid.Row>
                          <Grid.Column width={6}>Status Tag:</Grid.Column>
                          <Grid.Column width={8} className="bold-font">
                            {statusTagMapping[e.statusTag]}
                          </Grid.Column>
                        </Grid.Row>
                      )}

                      <Grid.Row>
                        <Grid.Column width={6}> Assigned RM Buddy:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {" "}
                          {e.assignedTo ? e.assignedTo.name : "NULL"},{" "}
                          {e.assignedTo && e.assignedTo.mobileNumber}{" "}
                        </Grid.Column>
                      </Grid.Row>
                      {taskStatus === "REASSIGNED" && (
                        <Grid.Row>
                          <Grid.Column width={6}>
                            {" "}
                            Previous RM Buddy:
                          </Grid.Column>
                          <Grid.Column width={8} className="bold-font">
                            {" "}
                            {e.assignedUserLog.length > 0
                              ? e.assignedUserLog[0].rmBuddyId.name
                              : "NULL"}
                            ,{" "}
                            {e.assignedUserLog.length > 0 &&
                              e.assignedUserLog[0].rmBuddyId.mobileNumber}{" "}
                          </Grid.Column>
                        </Grid.Row>
                      )}
                      <Grid.Row>
                        <Grid.Column width={6}>Buddy Block:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {" "}
                          {e.belongsToBuddyBlock
                            ? e.belongsToBuddyBlock.properties.name
                            : ""}{" "}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={6}>Order Number:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {e.orderNumbers.reduce(
                            (acc, oN) => (acc += `# ${oN}, `),
                            ""
                          )}{" "}
                        </Grid.Column>
                      </Grid.Row>
                      {e.serviceRequestId && (
                        <Grid.Row>
                          <Grid.Column width={6}>
                            Root Service Request Id:
                          </Grid.Column>
                          <Grid.Column width={8} className="bold-font">
                            {e.serviceRequestId}
                          </Grid.Column>
                        </Grid.Row>
                      )}
                      <Grid.Row>
                        <Grid.Column width={6}>Customer Name:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {e.customerInfo.fullName}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={6}>
                          Customer Mobile Number:
                        </Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {e.customerInfo.mobileNumber}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={6}>Due At:</Grid.Column>
                        <Grid.Column width={8} className="bold-font">
                          {moment(e.dueAt).format("YYYY-MM-DD h:mm a")}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <br />
                    <br />
                    <div className="TaskDetailsChecklist">
                      <Checkbox
                        readOnly
                        label="Society Verification"
                        checked={e.checkList.societyVerification}
                      />
                      <br />
                      <Checkbox
                        readOnly
                        label="Docs at Delivery"
                        checked={e.checkList.docsAtDelivery}
                      />
                    </div>
                    <br />
                  </div>
                ))}
              </div>
              <br />
              <div className="TaskActionButtonsContainer">
                {checkSelectedTasksContains(taskDetails, [
                  "PENDING",
                  "DELAYED"
                ]) && (
                  <MarkAsDoneButton
                    taskIds={taskDetails.map(e => e._id)}
                    onSuccessAction={onSuccessAction}
                  />
                )}
                &nbsp; &nbsp;
                {checkSelectedTasksContains(taskDetails, [
                  "PENDING",
                  "DELAYED",
                  "RMBUDDY_COMPLETE"
                ]) && (
                  <TransferTaskButton
                    onSuccessAction={onSuccessAction}
                    text={"Transfer Task"}
                    taskIds={taskDetails.map(e => e._id)}
                    taskAssignedTo={taskDetails
                      .map(e => e.assignedTo)
                      .filter(e => !isEmpty(e))}
                  />
                )}
                {checkSelectedTasksContains(taskDetails, ["UNALLOCATED"]) && (
                  <TransferTaskButton
                    onSuccessAction={onSuccessAction}
                    text={"Assign RM Buddy"}
                    taskIds={taskDetails.map(e => e._id)}
                    taskAssignedTo={taskDetails
                      .map(e => e.assignedTo)
                      .filter(e => !isEmpty(e))}
                  />
                )}
              </div>
            </Grid.Column>
          )}
        </Grid>
      ) : (
        <h3> No Tasks </h3>
      )}
    </div>
  );
}

function TasksTabs({ showDueDates }) {
  const tasksList = useSelector(
    ({ rmBuddies }) => rmBuddies.visibleRmBuddyTasks || [],
    shallowEqual
  );
  const unallocatedTasks = useSelector(
    ({ rmBuddies }) => rmBuddies.visibleUnallocatedRmBuddyTasks || [],
    shallowEqual
  );

  const delayedTasks = useSelector(
    ({ rmBuddies }) => rmBuddies.visibleDelayedRmBuddyTasks || [],
    shallowEqual
  );

  const reassignedTasks = useMemo(
    () => [
      ...tasksList.filter(e => e.assignedUserLog.length > 0),
      ...delayedTasks.filter(e => e.assignedUserLog.length > 0)
    ],
    [tasksList, delayedTasks]
  );

  const completeList = useMemo(
    () =>
      tasksList.filter(
        e => e.status === "RMBUDDY_COMPLETE" || e.status === "COMPLETE"
      ),
    [tasksList]
  );
  const inProgressList = useMemo(
    () => tasksList.filter(e => e.status === "PENDING"),
    [tasksList]
  );

  const cancelledTasks = useMemo(
    () => tasksList.filter(e => e.status === "CANCELLED"),
    [tasksList]
  );

  const tasksDueDateFilter = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksDueDateFilter
  );

  const [activeIndex, setActiveIndex] = useState(
    inProgressList.length > 0 ? 0 : 1
  );
  const handleTabChange = (e, { activeIndex }) => setActiveIndex(activeIndex);
  const [openFilter, setOpenFilter] = useState(false);

  const panes = useMemo(
    () => [
      {
        menuItem: (
          <Menu.Item key="1">
            Tasks in progress
            <Label circular className="PENDING">
              {inProgressList.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              tasksList={inProgressList}
              taskStatus={"PENDING"}
            />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="2">
            Completed Tasks
            <Label circular className="RMBUDDY_COMPLETE">
              {completeList.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              tasksList={completeList}
              taskStatus={"RMBUDDY_COMPLETE"}
            />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="3">
            All Delayed Tasks
            <Label circular className="DELAYED">
              {delayedTasks.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent tasksList={delayedTasks} taskStatus={"DELAYED"} />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="4">
            Transferred Tasks
            <Label circular className="REASSIGNED">
              {reassignedTasks.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              tasksList={reassignedTasks}
              taskStatus={"REASSIGNED"}
            />
          </Tab.Pane>
        )
      },

      {
        menuItem: (
          <Menu.Item key="5">
            Unallocated Tasks
            <Label circular className="UNALLOCATED">
              {unallocatedTasks.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              tasksList={unallocatedTasks}
              taskStatus={"UNALLOCATED"}
            />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="6">
            Cancelled Tasks
            <Label circular className="Cancelled">
              {cancelledTasks.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              tasksList={cancelledTasks}
              taskStatus={"CANCELLED"}
            />
          </Tab.Pane>
        )
      }
    ],
    [
      inProgressList,
      completeList,
      unallocatedTasks,
      delayedTasks,
      reassignedTasks,
      cancelledTasks
    ]
  );

  return (
    <div>
      <h4>
        SCHEDULE{" "}
        {showDueDates && (
          <span>
            {tasksDueDateFilter.fromDate.format("LL") !==
            tasksDueDateFilter.toDate.format("LL")
              ? `${tasksDueDateFilter.fromDate.format(
                  "DD MMM YYYY"
                )} to ${tasksDueDateFilter.toDate.format("DD MMM YYYY")}`
              : `${tasksDueDateFilter.fromDate.format("DD MMM YYYY")}
            `}
          </span>
        )}
        <Popup
          on="click"
          className="RMBuddyTasksFilterPopup"
          open={openFilter}
          onOpen={() => setOpenFilter(true)}
          position="bottom right"
          style={{
            padding: 0,
            boxShadow: "none",
            border: "none",
            background: "#323235",
            borderRadius: "12px"
          }}
          trigger={
            <img
              onClick={() => setOpenFilter(!openFilter)}
              style={{
                position: "absolute",
                right: "50px",
                height: "20px",
                cursor: "pointer"
              }}
              alt="Filter"
              src={`${process.env.PUBLIC_URL}/filter.png`}
            />
          }
        >
          <RMBuddyTasksFilter onApply={() => setOpenFilter(false)} />
        </Popup>
      </h4>
      {(tasksList || unallocatedTasks) && (
        <div className="TasksTabs">
          <Tab
            menu={{ secondary: true, pointing: true }}
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            panes={panes}
          />
        </div>
      )}
    </div>
  );
}

export { TasksTabs, TasksPaneContent };
